import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form";
import FormButton from "../FormButton";
import { useEffect, useState } from "react";
import { getNotificationDataHttp, sendNotification } from "../../http/renewalHttp/RenewalHttp";
import Input from "../Input";
import Select from "../Select";
import { notification_type } from "../../util/enum";

export default function SendNotificationModal({ notify, handleClicked, ...props }) {
  const [customer, setCustomer] = useState(false);
  const [contacts, setContacts] = useState([])
//   const [additionalContacts, setAdditionalContacts] = useState([]); // Array to store additional email & phone inputs
//   const [removedContacts, setRemovedContacts] = useState([]); // Array to store removed contacts (email:phone string)
//   const [addedContacts, setAddedContacts] = useState([]); // Array to store added contacts (email:phone string)
    const [renewalNotificationSelect, setRenewalNotificationSelect] = useState('')
  useEffect(() => {
    async function fetchNotificationData() {
        const initialContacts = [];
      const response = await getNotificationDataHttp(notify);
      setCustomer(response.zoho_customer);
      response.zoho_customer?.email?.forEach((email, index) => {
        initialContacts.push({
            email: email,
            phone : response.zoho_customer?.phone[index]
        })
      });
      setContacts(initialContacts);
    }
    fetchNotificationData();
  }, [notify]);

  function handleClose() {
    handleClicked(false);
  }

  function handleInputChange(index, field, event) {
    const updatedContacts = [...contacts];
    updatedContacts[index][field] = event.target.value;
    setContacts(updatedContacts);
  }

   const highlights = notification_type.type.map((highlight) =>     
              <option key={highlight.id}
                  name={highlight.id}
                  value={highlight.id}>
                  {highlight.value}</option>);

  function handleAddContact() {
    setContacts([...contacts, { email: "", phone: "" }]);
  }

  function handleRemoveContact(index) {
    setContacts(contacts.filter((_, i) => i !== index));
  }

  function handleSendNotification(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    const requestBody = {
      domain_name: customer?.domain_name,
      customer_name: customer?.customer_name,
      company_name: customer?.company_name,
      emails: contacts.map(c => c.email).filter(email => email),
      phones: contacts.map(c => c.phone).filter(phone => phone),
      zoho_customer: notify.zoho_contact_id,
      subscriptionId : notify.subscription_id, 
      renewalDate : notify.renewal_date,
      renewal_id : notify.renewal_id,
      notification_type : renewalNotificationSelect
    };
    console.log(data)
    console.log("Sending Data:", requestBody);
    sendNotification(requestBody);
    handleClicked(false)
    // // window.location.reload();
  }

  return (
    customer && createPortal(
      <Div className="modal-backdrop">
        <dialog {...props} style={{ zIndex: 1, maxWidth: "100%" }}>
          <Div className="form-group">Send Notification</Div>
          <Form onSubmit={handleSendNotification}>
            <Div className="form-group">
              <Input value={customer.domain_name} name="domain_name" type="text" className="form-control" disabled />
            </Div>

            <Div className="form-group">
              <label>Customer Name</label>
              <Input value={customer.customer_name} name="customer_name" type="text" className="form-control" disabled />
            </Div>

            <Div className="form-group">
              <label>Company Name</label>
              <Input value={customer.company_name} name="company_name" type="text" className="form-control" disabled />
            </Div>

            {contacts.map((contact, index) => (
              <Div className="form-group" key={index} style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flexGrow: 1 }}>
                  <label>Email</label>
                  <Input value={contact.email} type="text" onChange={(event) => handleInputChange(index, "email", event)} className="form-control" />
                </div>
                <div style={{ flexGrow: 1 }}>
                  <label>Phone</label>
                  {console.log(contact)}
                  <Input value={contact.phone} type="text" onChange={(event) => handleInputChange(index, "phone", event)} className="form-control" />
                </div>
                <FormButton type="button" onClick={() => handleRemoveContact(index)} className="btn btn-danger" style={{ marginTop: "30px", marginLeft: "10px" }}>
                  Remove
                </FormButton>
              </Div>
            ))}

            <Div className="form-group">
              <FormButton type="button" onClick={handleAddContact} className="btn btn-secondary">Add Contact</FormButton>
            </Div>

            <Div className="form-group">
              
                <Select name='highlight' options={highlights} defaultValue="Select Renewal Type"
                     onChange={e => setRenewalNotificationSelect(e.target.value)} style={{ width: 'auto' }} />
            </Div>

            <Div className="form-group">
              <Div className="row">
                <Div className="col-sm-6">
                  <FormButton type="submit" className="btn btn-primary submit-btn btn-block">Send Notification</FormButton>
                </Div>
                <Div className="col-sm-6">
                  <FormButton type="button" onClick={handleClose} className="btn btn-primary submit-btn btn-block">Close</FormButton>
                </Div>
              </Div>
            </Div>
          </Form>
        </dialog>
      </Div>,
      document.getElementById("modal")
    )
  );
}
